import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsPrice from './components/Settings/SettingsPrice'
import SettingsStep from './components/Settings/SettingsStep'

import {
  setTitle
} from 'common/redux/root'

import {
  savePriceCategories, updatePrice, fetchAgentMvipSettings
} from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsPriceContainer extends Component {

  componentWillMount() {
    this.props.dispatch(setTitle("My Price Ranges"))
    this.props.dispatch(fetchAgentMvipSettings())
  }

  handleSubmit = cb => {
    const { dispatch, settings } = this.props
    if (this.isValid()) {
      dispatch(savePriceCategories(settings.price_categories)).then(cb)
    }

  }

  handleSelect = (key, enabled) => {
    const { auth, dispatch } = this.props
    const isEmerging = auth.user.agent_experience_level === 'emerging'
    if (!isEmerging) {
      dispatch(updatePrice(key, enabled))
    }
  }

  isValid = () => {
    const { auth, settings } = this.props
    const isEmerging = auth.user.agent_experience_level === 'emerging'
    return settings.price_categories && Object.keys(settings.price_categories).length !== 0 && !isEmerging
  }

  render() {
    const { auth } = this.props
    const isEmerging = auth.user.agent_experience_level === 'emerging'

    return <SettingsStep shouldDisableSubmit={!this.isValid()} onSubmit={this.handleSubmit} {...this.props}>
      { isEmerging ? <div className="SettingsHome__emerging">
        <div>
          <div/>
          <div>As an <strong>emerging agent,</strong> you must <strong>close 1 client</strong> before you can set price categories.</div>
        </div>
      </div> : null }
      <SettingsPrice onSelect={this.handleSelect} {...this.props} />
    </SettingsStep>
  }

}

export default connect((state) => ({ auth: state.auth, settings: state.settings }), mapDispatchToProps)(SettingsPriceContainer)
